import React from "react";
import isTouchDevice from "../SE-Component/Tooltip";
// import keyImage from "../../images/se-plc.png";
// import keyImage from "../../images/SN_M251.jpg";
import Tooltip from "../../utils/Tooltip";

const serialNoRegex_13 = /^[a-zA-Z0-9]{8}[0-9]{5}$/;
const serialNoRegex_10 = /^[a-zA-Z0-9]{5}[0-9]{5}$/;
const DownloadController = ({
  controller,
  serialNumber,
  handleSerialNo,
  handleSerialNoPopUpClose,
  handleSerialNoSave,
  keyImage,
  title,
  status,
  isDisplayKeyImage,
  maxLength = 10
}) => {
  const checkMaxLength = (value) => {
    if(maxLength === 10){
      return serialNoRegex_10.test(value);  
    }else{
      return serialNoRegex_13.test(value);  
    }
  }
  return (
    <se-dialog
      id="dialog-complex"
      size="medium"
      open={status}
      can-backdrop="false"
    >
      <se-dialog-header>{title}</se-dialog-header>
      <se-dialog-content>
        <div className="col-md-12 se-white-background">
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-6 col-form-label">
              Controller serial number (SN){" "}
              <span className="se-mandatory">* </span>
              <Tooltip 
                    position ="right"                   
                    iconColor ="secondary"
                    iconSize = "small"                   
                    information ={`Enter ${maxLength} alphanumeric characters for serial number. Refer image below`}
                    />
             
            </label>
            <div className="col-sm-6">
              <input
                type="text"
                autoComplete="none"
                className="form-control form-control-md"
                name="serialNo"
                placeholder="Please enter controller serial number (SN)"
                maxLength={maxLength}
                // disabled={serialNumber || false}
                value={controller.serialNo}
                onChange={(e)=>handleSerialNo(e)}
              />
              {controller.serialNo === "" &&
                controller.KeyErrorStatusSerialNo && (
                  <div className="invalid-feedback-custom">
                    Controller serial number (SN) is required .
                  </div>
                )}
              {controller.serialNo !== "" &&
                controller.serialNo.length !== maxLength && (
                  <div className="invalid-feedback-custom">
                    {`Invalid controller serial number. Maximum ${maxLength} characters `}
                  {isDisplayKeyImage &&  <span>and last 5 characters should always be a decimal value 0-9</span>}
                  </div>
                )}
              {!checkMaxLength(controller.serialNo) &&
                controller.serialNo.length === maxLength && (
                  <div className="invalid-feedback-custom">
                   {` Invalid controller serial number. Maximum ${maxLength} characters and
                    last 5 characters should always be a decimal value 0-9`}
                  </div>
                )}
            </div>
          </div>

       {  isDisplayKeyImage &&  
       <div className="row">
            <div className="col-md-12">
              <label>Reference Image:</label> 
            </div>
            <div className="col-md-12 text-center">
              <img
                src={keyImage}
                className="img-fluid height-250px"
                title="Serial key "
                alt="Serial key "
                height="400"
                
              ></img>
            </div>
          </div>}
        </div>
      </se-dialog-content>
      <se-dialog-footer>
        <se-button onClick={handleSerialNoPopUpClose}>Cancel</se-button>
        <se-button onClick={handleSerialNoSave}>OK</se-button>
      </se-dialog-footer>
    </se-dialog>
  );
};

export default DownloadController;
